// extracted by mini-css-extract-plugin
export var align_center = "Spacer-module--align_center--c237b";
export var justify_center = "Spacer-module--justify_center--cb4a7";
export var justify_space_between = "Spacer-module--justify_space_between--b6b93";
export var large = "Spacer-module--large--871d8";
export var medium = "Spacer-module--medium--c178b";
export var none = "Spacer-module--none--d1acf";
export var small = "Spacer-module--small--e0d95";
export var spacerHorizontal = "Spacer-module--spacerHorizontal--be212";
export var spacerNoWrap = "Spacer-module--spacerNoWrap--f155e";
export var spacerVertical = "Spacer-module--spacerVertical--537a6";
export var xsmall = "Spacer-module--xsmall--8b11a";